<template>
  <div class="contents">
    <h2>振出振休残CSVダウンロード</h2>
    <div class="container">
      <template v-if="isLoading">
        <template v-if="!isError">
          <loading :isLoading="isLoading" :message="'読み込み中...'"></loading>
        </template>
      </template>
      <template v-else>
        <div class="flex">

          <div class="maininfo flex">

            <div class="btn-container">
              <button type="button" class="btn success" @click="downloadFurideCSV" :disabled="isLoading || isCreating">
                <template v-if="isCreating">
                  <i class="fa-solid fa-spinner fa-spin-pulse"></i>CSVダウンロード中…
                </template>
                <template v-else>
                  <i class="fa-solid fa-floppy-disk"></i>CSVダウンロード
                </template>
              </button>
            </div>

          </div><!-- /maininfo -->
        </div>
      </template>

    </div>

  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import { useInit } from '@/composable/furidecsv/init';
import { useCreate } from '@/composable/furidecsv/create';

export default defineComponent({
  setup() {
    // 初期化
    const { isLoading, isError } = useInit();
    const { isCreating, downloadFurideCSV } = useCreate();

    return {
      isLoading,
      isCreating,
      isError,
      downloadFurideCSV,
    }
  },
  components: {

  }
})
</script>

<style lang="scss" scoped>
</style>
